import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-340c1ab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bookview-main-container" }
const _hoisted_2 = { class: "bookview-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "close-page",
  class: "close-icon"
}, "×", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "bookview-image-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  controls: "",
  autoplay: ""
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "scene-text"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  id: "myModal",
  class: "modal"
}
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePage && _ctx.closePage(...args)))
        }, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.itemInfo.type === 'image')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.itemInfo.url,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.itemInfo.type === 'video')
            ? (_openBlock(), _createElementBlock("video", _hoisted_7, [
                _createElementVNode("source", {
                  src: _ctx.itemInfo.url,
                  type: "video/mp4"
                }, null, 8, _hoisted_8),
                _createTextVNode(" Your browser does not support the video tag. ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.itemInfo.type === 'text')
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.itemInfo.content), 1))
            : _createCommentVNode("", true),
          (_ctx.itemInfo.type === 'link')
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 3,
                src: _ctx.itemInfo.url,
                allowfullscreen: ""
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", {
        class: "close-modal",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, "×"),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("img", {
          class: "modal-content-img",
          src: _ctx.itemInfo.url
        }, null, 8, _hoisted_13)
      ])
    ], 512), [
      [_vShow, _ctx.isModalOpen]
    ])
  ], 64))
}